export default "<p>\r\n  services works!\r\n</p>\r\n";